let connection;
if (window.navigator) {
  connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
}

export default {
  getNetworkType() {
    if (!connection) {
      return;
    }

    return connection.type;
  },
  getSignalLevel() {
    if (!connection) {
      return;
    }

    return connection.effectiveType;
  },
};
